import { api } from 'guardian-js-shared';
import { getContextAuthResource } from 'speed-js-core';
import APIKey from 'guardian/admin/api/resources/APIKey';

export default {
    ...api.resources,

    apiKeys: APIKey,

    auth: getContextAuthResource('core'),
};
